'use client'

import React from 'react'

import { Code2 } from 'lucide-react'
import { useTranslations } from 'next-intl'

import { Button, type ButtonProps } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip'

import { cn } from '@/utils'

import { useToolbar } from './toolbar-provider'

const CodeToolbar = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, onClick, ...props }, ref) => {
    const { editor } = useToolbar()
    const t = useTranslations('components.tiptap.toolbars')

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            className={cn(
              'h-8 w-8 p-0 sm:h-9 sm:w-9',
              editor?.isActive('code') && 'bg-accent',
              className
            )}
            disabled={!editor?.can().chain().focus().toggleCode().run()}
            onClick={(e) => {
              editor?.chain().focus().toggleCode().run()
              onClick?.(e)
            }}
            ref={ref}
            size="icon"
            type="button"
            variant="ghost"
            {...props}
          >
            {children ?? <Code2 className="h-4 w-4" />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <span>{t('code')}</span>
        </TooltipContent>
      </Tooltip>
    )
  }
)

CodeToolbar.displayName = 'CodeToolbar'

export { CodeToolbar }
